import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import DomainProgressReport from '../components/domain-progress/domain-progress-report';
import DomainPortfolioReport from '../components/domain-portfolio/domain-portfolio-report';
import PolicyProgressReport from '../components/policy-progress/policy-progress-report';
import ReportContent from '../components/report-content';

import { handleReportsInitialLoad } from '../../common/actions/datepicker-action-creators';
import { switchReportTabs } from '../../common/actions/ui-state-action-creators';
import { reportHeaderSelector } from '../selectors/reports-selectors';
import { reportMap } from '../constants/reports';

export const ReportContentContainer = ( {
    handleReportsInitialLoad, header, match, switchReportTabs
} ) => {
    const reportContentMap = {
        domainPortfolio: DomainPortfolioReport,
        domainProgress: DomainProgressReport,
        policyProgress: PolicyProgressReport,
    };

    let selectedReport, Report;

    if( reportMap[match.params.reportId] ){
        selectedReport = reportMap[match.params.reportId];
        Report = reportContentMap[selectedReport.content];
        switchReportTabs( selectedReport.index, match.params.reportId );
    }
    else{
        return <Redirect to={{ pathname: `/reports/${reportMap['domain-progress'].url}` }} />;
    }

    return (
        <ReportContent
            content={ <Report onInitialLoad={handleReportsInitialLoad} /> }
            match={match}
            switchReportTabs={switchReportTabs}
            handleReportsInitialLoad={handleReportsInitialLoad}
            header={header}
            selectedReport={selectedReport}
        />
    );
};

/* istanbul ignore next */
const mapStateToProps = ( state ) => {
    return {
        header: reportHeaderSelector( state )
    };
};

ReportContentContainer.propTypes = {
    handleReportsInitialLoad: PropTypes.func.isRequired,
    header: PropTypes.object.isRequired,
    match: PropTypes.shape( {
        params: PropTypes.object,
        url: PropTypes.string
    } ),
    switchReportTabs: PropTypes.func.isRequired,
};

export default connect( mapStateToProps, { handleReportsInitialLoad, switchReportTabs } )( ReportContentContainer );
